export { default } from "./ProceedToCheckoutButton.jsx";
